import { Box, StandardTextFieldProps, SxProps, TextField, Typography } from "@mui/material";
import { useState } from "react";
import { Control, Controller, FieldValues, RegisterOptions } from "react-hook-form";
import { colors } from "../../theme/colors";

const Input = ({
  label,
  sx,
  wrapperSx = {},
  control,
  rules,
  widthAuto,
  name,
  onChange,
  required,
  maxLength,
  minLength,
  fullWidth,
  valueLength,
  ...props
}: StandardTextFieldProps & {
  maxLength?: number;
  minLength?: number;
  control: Control<FieldValues>;
  name: string;
  rules?: RegisterOptions;
  widthAuto?: boolean;
  wrapperSx?: SxProps;
  valueLength?: number;
}) => {
  const [characters, setCharacters] = useState(valueLength || 0);
  const inputId = `input-${name}`;
  const helperTextId = `${name}-helper-text`;

  return (
    <Controller
      defaultValue={""}
      name={name}
      control={control}
      rules={rules}
      render={({ field: { onChange: onChangeField, ...rest } }) => (
        <Box
          sx={(theme) => ({
            width: widthAuto ? "auto" : "100%",
            maxWidth: fullWidth ? "none" : theme.spacing(100),
            ...(wrapperSx as object)
          })}
          mb={3}>
          {label !== undefined && (
            <Box
              sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}
              mb={1}>
              <Typography
                component="label"
                htmlFor={inputId}
                variant="body2"
                sx={(theme) => ({
                  color: props.error ? theme.palette.error.main : theme.palette.text.primary
                })}>
                {label}
                {required && "*"}
              </Typography>

              {(maxLength || minLength) && (
                <Typography
                  variant="caption"
                  sx={(theme) => ({
                    color: theme.palette.mode === "dark" ? colors.lightGrey : colors.grey
                  })}>
                  {`${minLength ? `${minLength}/` : ""}${characters}${
                    maxLength ? `/${maxLength}` : ""
                  }`}
                </Typography>
              )}
            </Box>
          )}
          <TextField
            sx={{ width: "100%", ...sx }}
            onChange={(e) => {
              setCharacters(e.target.value?.length ?? 0);
              onChangeField(e);
              onChange && onChange(e);
            }}
            required={required}
            fullWidth
            inputProps={{
              id: inputId,
              "aria-describedby": props.helperText ? helperTextId : undefined
            }}
            FormHelperTextProps={{ id: props.helperText ? helperTextId : undefined }}
            aria-invalid={props.error || undefined}
            {...props}
            {...rest}
          />
        </Box>
      )}
    />
  );
};

export default Input;
